import { Timestamp } from "firebase/firestore";
import { isAfter, startOfDay } from "date-fns";
import { TASK_TYPE, TASK_PRIORITY, TASK_STATUS } from "../../constants/tasks";

/**
 * Converte os dados do formulário/tabela de Tarefa para a estrutura do Firestore (desnormalizado).
 */
const resolveInitialStatus = (data) => {
    let status = data.status || TASK_STATUS.NEW;
    if (status === TASK_STATUS.NEW && data.scheduledDate) {
        try {
            let dateObj = data.scheduledDate.includes('T') 
                ? new Date(data.scheduledDate) 
                : new Date(data.scheduledDate + 'T' + (data.scheduledTime || '00:00:00'));
                
            if (isAfter(startOfDay(dateObj), startOfDay(new Date()))) {
                status = TASK_STATUS.SCHEDULED;
            }
        } catch (e) {}
    }
    return status;
};

export const taskToFirestore = (data, tenant, authUser) => {
    return {
        idTenant: tenant.idTenant,
        title: data.title?.trim() || "",
        description: data.description?.trim() || "",
        type: data.type || TASK_TYPE.CONTACT,
        priority: data.priority || TASK_PRIORITY.NORMAL,
        status: resolveInitialStatus(data),
        
        scheduledDate: data.scheduledDate || null,
        scheduledTime: data.scheduledTime || null,

        // Desnormalizando as informações do membro
        idMember: data.selectedMember?.id || null,
        memberName: data.selectedMember?.fullName || data.selectedMember?.label || null,
        memberEmail: data.selectedMember?.email || null,
        memberPhone: data.selectedMember?.phone || null,
        memberPhotoUrl: data.selectedMember?.photoUrl || null,

        // Desnormalizando as informações do funcionário responsável (compatibilidade legada)
        idEmployee: data.selectedEmployees?.[0]?.id || null,
        employeeName: data.selectedEmployees?.[0]?.fullName || data.selectedEmployees?.[0]?.name || null,
        employeeEmail: data.selectedEmployees?.[0]?.email || null,
        employeePhone: data.selectedEmployees?.[0]?.phone || null,
        employeePhotoUrl: data.selectedEmployees?.[0]?.photoUrl || null,
        
        // Múltiplos responsáveis
        assignedEmployees: (data.selectedEmployees || []).map(emp => ({
            id: emp.id || null,
            name: emp.fullName || emp.name || null,
            email: emp.email || null,
            phone: emp.phone || null,
            photoUrl: emp.photoUrl || null})),
        
        // ═══ CRM: Dados de Contato e Follow-up ═══
        contactReason: data.contactReason || null,
        contactOutcome: data.contactOutcome || null,
        outcomeNotes: data.outcomeNotes || null,
        outcomeDate: data.outcomeDate || null,
        contactAttempts: data.contactAttempts || 0,
        lastContactAt: data.lastContactAt || null,
        lossReason: data.lossReason || null,
        outcomeHistory: data.outcomeHistory || [],

        // Relacionamentos Futuros
        idFinancialRecord: null,

        // Auditoria
        createdAt: data.id ? data.createdAt : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? data.createdBy : { uid: authUser?.uid, name: authUser?.displayName || authUser?.email || "Sistema" },
        updatedBy: { uid: authUser?.uid, name: authUser?.displayName || authUser?.email || "Sistema" }
    };
};
